import React, { useState } from "react";
import { Stage, Layer, Rect, Image } from "react-konva";
import Icon from "../Icon";
import DrawRect from "./DrawRect";

const DrawCanvas = (props) => {
  const {
    background,
    canvasWidth,
    canvasHeight,
    scale,
    stageRef,
    bgRef,
    rects,
    setRects,
    triggers,
    points,
    minScale,
    colorPickerVisible,
    readFill,
    readOpacity,
  } = props;
  const [newRect, setNewRect] = useState([]);

  const handleMouseDown = (e) => {
    //if we are not clicking on a rect and new rect is empty, start drawing new rect
    if (e.target.name() !== "rect" && newRect.length === 0) {
      const x = e.target.getStage().getPointerPosition().x / scale.x; // need to compensate here for the canvas scale
      const y = e.target.getStage().getPointerPosition().y / scale.x; // need to compensate here for the canvas scale
      setNewRect([{ x, y, width: 0, height: 0, key: "0" }]);
    }
  };

  const handleMouseMove = (e) => {
    if (newRect.length > 0) {
      const origX = newRect[0].x;
      const origY = newRect[0].y;
      const x = stageRef.current.getPointerPosition().x / scale.x;
      const y = stageRef.current.getPointerPosition().y / scale.x;
      setNewRect([
        {
          x: origX,
          y: origY,
          width: x - origX,
          height: y - origY,
        },
      ]);
    }
  };

  const handleMouseUp = (e) => {
    if (newRect.length === 1) {
      let w = Math.abs(newRect[0].width);
      let h = Math.abs(newRect[0].height);
      // if the user clicked, or intended to click
      // (and maybe dragged a small box in the process),
      // then we will cancel the rect drawing
      if (w < minScale && h < minScale) {
        setNewRect([]);
        return;
      }

      const origX = newRect[0].x;
      const origY = newRect[0].y;
      const x = e.target.getStage().getPointerPosition().x / scale.x;
      const y = e.target.getStage().getPointerPosition().y / scale.x;
      const rectToAdd = {
        id: rects.length,
        x: Math.min(x, origX),
        y: Math.min(y, origY),
        width: Math.max(minScale, w),
        height: Math.max(minScale, h),
        startTime: 0,
        pauseAfter: false,
        iterations: [],
      };
      let temp = rects.slice();
      temp.push(rectToAdd);
      setNewRect([]);
      setRects(temp);
    }
  };

  const rectsToRender = [...rects, ...newRect];

  return (
    <div className="canvas">
      <Stage
        scale={scale}
        ref={stageRef}
        width={canvasWidth}
        height={canvasHeight}
        // onContextMenu={showContextMenu}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
      >
        <Layer>
          <Image image={background} ref={bgRef} />
        </Layer>
        <Layer>
          {triggers &&
            triggers.map((trigger, index) => {
              if (trigger.type === "rect") {
                return (
                  <Rect
                    key={index}
                    x={trigger.x}
                    y={trigger.y}
                    width={trigger.width}
                    height={trigger.height}
                    fill="#00000040"
                    stroke={"gray"}
                    opacity={0.4}
                    strokeWidth={1}
                    dash={[4, 3]}
                  />
                );
              } else {
                return (
                  <Icon
                    id={trigger.id}
                    key={trigger.id}
                    x={trigger.x}
                    y={trigger.y}
                    iconUrl={trigger.iconUrl}
                    color={trigger.color}
                    scale={trigger.scale}
                    canvasWidth={canvasWidth}
                    canvasHeight={canvasHeight}
                    canvasScale={scale}
                    opacity={0.25}
                  />
                );
              }
            })}
        </Layer>
        <Layer>
          {rectsToRender &&
            rectsToRender.map((rect, index) => {
              return (
                <DrawRect
                  key={index}
                  index={index}
                  name={"rect"}
                  rect={rect}
                  fill={colorPickerVisible ? readFill : "orange"}
                  opacity={colorPickerVisible ? readOpacity : 0.3}
                />
              );
            })}
          {points &&
            points.map((point) => {
              return (
                <Icon
                  id={point.id}
                  key={point.id}
                  x={point.x}
                  y={point.y}
                  iconUrl={point.iconUrl}
                  // customText={point.customText}
                  color={point.color}
                  scale={point.scale}
                />
              );
            })}
        </Layer>
      </Stage>
    </div>
  );
};

export default DrawCanvas;
